const normalizedEmail = (value) => {
  const email = value?.trim().toLowerCase()
  return email || ''
}

export const emailsMatch = (trustee, employee) => {
  const mail = normalizedEmail(trustee?.mail)
  const email = normalizedEmail(employee?.email)
  return Boolean(mail && email && mail === email)
}

export const uniqueEmployeeForTrustee = (trustee, candidates) => {
  const matches = candidates.filter((employee) => emailsMatch(trustee, employee))
  if (matches.length !== 1) {
    return null
  }
  return matches[0]
}
